import { PieSeriesOption } from 'echarts/charts';
import { LegendComponentOption, TitleComponentOption, TooltipComponentOption } from 'echarts/components';
import * as echarts from 'echarts/core';
import { ForwardedRef, forwardRef, ReactElement } from 'react';
import Echarts, { ChartHandle, EchartsProps } from './Echarts';

export type PieChartOption = echarts.ComposeOption<
  TitleComponentOption | TooltipComponentOption | LegendComponentOption | PieSeriesOption
>;

interface PieChartProps extends EchartsProps<PieChartOption> {}

const PieChart = ({ option, onChartInitialized }: PieChartProps, ref: ForwardedRef<ChartHandle>): ReactElement => {
  return <Echarts ref={ref} option={option} onChartInitialized={onChartInitialized} />;
};

export default forwardRef<ChartHandle, PieChartProps>(PieChart);
